var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.create($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("files-image", {
                      attrs: {
                        options: {
                          id: "image",
                          label: "image",
                          error: _vm.fieldErrors.supplierImage
                        }
                      },
                      model: {
                        value: _vm.image,
                        callback: function($$v) {
                          _vm.image = $$v
                        },
                        expression: "image"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "name",
                          label: "name",
                          error: _vm.fieldErrors.name
                        }
                      },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = $$v
                        },
                        expression: "name"
                      }
                    }),
                    _c("select-supplier-types", {
                      attrs: {
                        options: {
                          id: "supplier_type",
                          label: "type",
                          error: _vm.fieldErrors.type
                        }
                      },
                      model: {
                        value: _vm.type,
                        callback: function($$v) {
                          _vm.type = $$v
                        },
                        expression: "type"
                      }
                    }),
                    _c("select-supplier-fleets", {
                      attrs: {
                        options: {
                          id: "supplier_fleet",
                          label: "fleet",
                          error: _vm.fieldErrors.fleet
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "hint-top",
                          fn: function() {
                            return [
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "* (" +
                                    _vm._s(_vm.$t("labels.required")) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.fleet,
                        callback: function($$v) {
                          _vm.fleet = $$v
                        },
                        expression: "fleet"
                      }
                    }),
                    _c("select-countries", {
                      attrs: {
                        options: {
                          id: "country_id",
                          label: "country",
                          error: _vm.fieldErrors.countryId
                        }
                      },
                      model: {
                        value: _vm.country_id,
                        callback: function($$v) {
                          _vm.country_id = $$v
                        },
                        expression: "country_id"
                      }
                    }),
                    _vm.needPlatformID()
                      ? _c("select-platforms", {
                          attrs: {
                            options: {
                              id: "platform_id",
                              label: "platform",
                              error: _vm.fieldErrors.ownerId
                            }
                          },
                          model: {
                            value: _vm.platform_id,
                            callback: function($$v) {
                              _vm.platform_id = $$v
                            },
                            expression: "platform_id"
                          }
                        })
                      : _vm._e(),
                    _vm.needBrands()
                      ? _c("select-platform-brands", {
                          attrs: {
                            platform_id: _vm.platform_id,
                            options: {
                              id: "brands",
                              label: "brands",
                              error: _vm.fieldErrors.brandIds,
                              multiple: true
                            }
                          },
                          model: {
                            value: _vm.brandIds,
                            callback: function($$v) {
                              _vm.brandIds = $$v
                            },
                            expression: "brandIds"
                          }
                        })
                      : _vm._e(),
                    _c("input-checkbox", {
                      attrs: {
                        options: {
                          id: "wallet_enabled",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "wallet_enabled",
                          error: _vm.fieldErrors.usesWallet,
                          containerClass: "col-12 col-md-6 mt-5"
                        }
                      },
                      model: {
                        value: _vm.usesWallet,
                        callback: function($$v) {
                          _vm.usesWallet = $$v
                        },
                        expression: "usesWallet"
                      }
                    }),
                    _c("input-checkbox", {
                      attrs: {
                        options: {
                          id: "full_time_drivers",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "full_time_drivers",
                          error: _vm.fieldErrors.fullTimeDrivers,
                          containerClass: "col-12 col-md-6 mt-5",
                          disabled: _vm.needBrands()
                        }
                      },
                      model: {
                        value: _vm.fullTimeDrivers,
                        callback: function($$v) {
                          _vm.fullTimeDrivers = $$v
                        },
                        expression: "fullTimeDrivers"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: { to: { name: _vm.routePrefix + ".index" } }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit", disabled: _vm.loading }
                        },
                        [
                          _vm.loading
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm"
                              })
                            : _vm._e(),
                          _c("i", { staticClass: "fa fa-save" })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }